var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-page"},[_c('g-title',{attrs:{"tag":"h1","size":"s"}},[_vm._v(" Tack för allt du gjort - det var till mycket stor hjälp! ")]),_c('br'),_c('g-markdown',{attrs:{"content":_vm.copy}}),_c('br'),_c('br'),_c('br'),_c('br')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }